import { mainButton, themeParams, useSignal } from "@telegram-apps/sdk-react";
import React from "react";
import themeConfg from "~/assets/theme";

const useMainButton = ({
    text,
    isLoading,
    isShine = false,
    isEnabled = true,
    isVisible = true,
    onClick,
}: {
    text: string;
    onClick: () => void;
    isLoading?: boolean;
    isEnabled?: boolean;
    isShine?: boolean;
    isVisible?: boolean;
}) => {
    const isDark = useSignal(themeParams.isDark);

    React.useLayoutEffect(() => {
        const theme = isDark ? "dark" : "light";
        const colorsTheme = themeConfg.tgColors[theme];
        const backgroundColor = (colorsTheme["mainButton"].bgColor ??
            "#FF7400") as `#${string}`;
        const textColor = (colorsTheme["mainButton"].textColor ??
            "#FFFFFF") as `#${string}`;

        mainButton.setParams({
            isEnabled,
            isLoaderVisible: isLoading,
            isVisible: isVisible,
            backgroundColor,
            hasShineEffect: isShine,
            text,
            textColor,
        });

        return () => {
            mainButton.setParams({
                isVisible: false,
            });
        };
    }, [isDark, isEnabled, isLoading, isShine, isVisible, text]);

    React.useLayoutEffect(() => {
        const offClick = mainButton.onClick(onClick);

        return () => {
            offClick();
        };
    }, [onClick]);
};

export const resetMainButton = () => {
    mainButton.setParams({
        isVisible: false,
    });
};

export default useMainButton;
